// src/components/shell/useNavItems.ts
// Phase 6.7.1 - Shared nav items hook.
//
// Single source of truth for the primary navigation. Consumed by both:
//   - Sidebar (desktop, lg+ only)
//   - MobileSidebar (drawer, below lg)
//
// Adding a future nav item happens here, once.
import { useTranslation } from "react-i18next";
import {
  LayoutDashboard,
  Building2,
  Home,
  Users,
  FileSignature,
  Briefcase,
  BarChart3,
  Wrench,
  Wallet,
} from "lucide-react";
export interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}
export function useNavItems(): NavItem[] {
  const { t } = useTranslation();
  return [
    { to: "/app/dashboard", label: t("nav.dashboard"), icon: LayoutDashboard },
    { to: "/app/properties", label: t("nav.properties"), icon: Building2 },
    { to: "/app/units", label: t("nav.units"), icon: Home },
    { to: "/app/tenants", label: t("nav.tenants"), icon: Users },
    { to: "/app/leases", label: t("nav.leases"), icon: FileSignature },
    { to: "/app/maintenance", label: t("nav.maintenance"), icon: Wrench },
    { to: "/app/finance", label: t("nav.finance", "Finance"), icon: Wallet },
    { to: "/app/owners", label: t("nav.owners"), icon: Briefcase },
    { to: "/app/reports", label: t("nav.reports"), icon: BarChart3 },
  ];
}
